function getLocationColor(lat, long) {
  const DE_borderNorth = 55;
  const DE_borderSouth = 46;
  const DE_borderEast = 15;
  const DE_borderWest = 5;
  // let DEBorder_north = 55.5738;
  // let DEBorder_south = 45.7313;
  // let DEBorder_east = 17.6126;
  // let DEBorder_west = 3.1766;
  const DE_hueMIN = 75;
  const DE_hueMAX = 150;
  const DE_lightnessMIN = 40;
  const DE_lightnessMAX = 60;

  const global_borderNorth = 77;
  const global_borderSouth = -55;
  const global_borderWest = -180;
  const global_borderEast = 180;
  const global_hueMIN = 0;
  const global_hueMAX = 360;
  const global_lightnessMIN = 10;
  const global_lightnessMAX = 90;

  let lightnessMIN;
  let lightnessMAX;
  let hueMIN;
  let hueMAX;
  let borderNorth;
  let borderSouth;
  let borderWest;
  let borderEast;
  const SATURATION = 40;
  let lightness;
  let hue;

  /*  
          coord format: (lat, long)
          min lat = 0 
          max lat = +/-90 N/S
          min long = 0
          max long = +/-180 W/E
          [-lat = south; -long = west]   

          Global extentBorder:
            ~unterster zipfel von south america -55.533786 (LAT), -67.537911
            ~oberes ender der sibirien-beule 77.375894 (LAT), 103.643953

          DE extentBorder: 
            north west:   55.573830, 3.176583
            south east:   45.731285, 17.612618
        */

  //LATITUDE  - LIGHTNESS
  if (DE_borderSouth < lat && lat < DE_borderNorth) {
    lightnessMIN = DE_lightnessMIN;
    lightnessMAX = DE_lightnessMAX;
    borderNorth = DE_borderNorth;
    borderSouth = DE_borderSouth;
  } else {
    lightnessMIN = global_lightnessMIN;
    lightnessMAX = global_lightnessMAX;
    borderNorth = global_borderNorth;
    borderSouth = global_borderSouth;
  }
  try {
    const lightnessRange = lightnessMAX - lightnessMIN;
    lightness =
      lightnessMIN + lightnessRange * ((lat - borderNorth) / (borderSouth - borderNorth));
    lightness = Math.round(lightness);
  } catch (e) {
    console.log("Node coordinates are out of global extent ");
    throw e;
  }

  //LONGITUDE - HUE
  if (DE_borderWest < long && long < DE_borderEast) {
    hueMIN = DE_hueMIN;
    hueMAX = DE_hueMAX;
    borderWest = DE_borderWest;
    borderEast = DE_borderEast;
  } else {
    if (long < DE_borderWest) {
      hueMIN = global_hueMIN;
      hueMAX = DE_hueMAX;
      borderWest = global_borderWest;
      borderEast = DE_borderWest;
    } else {
      hueMIN = DE_hueMAX;
      hueMAX = global_hueMAX;
      borderWest = DE_borderEast;
      borderEast = global_borderEast;
    }
  }
  const colorRange = hueMAX - hueMIN;
  hue = hueMIN + colorRange * ((long - borderWest) / (borderEast - borderWest));
  hue = Math.round(hue);

  return {
    h: hue,
    s: SATURATION,
    l: lightness,
  };
}

// from https://stackoverflow.com/questions/36721830/convert-hsl-to-rgb-and-hex
function hslToHexString(h, s, l) {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0"); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export default {
  getLocationColor,
  hslToHexString,
};
